import styled from "styled-components";

interface CircleProps {
  selected: boolean,
  value: number,
}
interface HeaderActiveProps {
  isActive: boolean
}
interface MenuItemProps {
  selected: boolean
}
export const StyledMenu = styled.div`
  width: 350px;
  border-radius: 8px;
  background-color: #f0f0f0;
`
export const StyledMenuItem = styled.div<MenuItemProps>`
  background-color: ${props=> props.selected && "#fff"};
  max-height: 100px;
  padding: 2px 20px;
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: ${props=> props.selected ? "1px solid #009688" : "1px solid #fff" };
  & span {
    max-width: 280px;
    font-size: 1.5rem;
  }
`


export const MenuHeader = styled.div<HeaderActiveProps>`
  cursor:pointer;
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  border-radius: 8px;
  color: ${props => props.isActive ? "#fff" : "#000"};
  background-color: ${props => props.isActive ? "#009688" : "#E2E2E2"};
  border-bottom: 1px solid #fff;
  & h4 {
    color: ${props => props.isActive ? "#fff" : "#000"};
    padding-left: 10px;
  }
 `
export const ColorCircle = styled.div<CircleProps>`
  background-color: ${props =>  props.value > -1  ? "#009688" : "#fff" };
  border: 2px solid #009688;
  border-radius: 50% 50%;
  width: 1rem;
  height: 1rem;
  margin-right: 20px;
`



// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/SidebarCriteriaMenu/SidebarCriteriaMenu.styled.ts